import { DocumentProps, pdf } from '@react-pdf/renderer';

export const handleOnClickReportDownload = async (
  report: React.ReactElement,
  fileName: string,
  setIsDownloadingReport: (arg: boolean) => void
) => {
  setIsDownloadingReport(true);
  const base64data = await getBase64PDF(report);
  if (base64data) {
    downloadBase64File(base64data, fileName);
  }
  setIsDownloadingReport(false);
};

export const sanitizeForFilename = (name: string): string => {
  const cleaned = name
    .replace(/[/\\:*?"<>|]/g, '_')
    .trim()
    .slice(0, 100)
    .trim();
  return cleaned || 'untitled';
};

export const getBase64PDF = async (report: React.ReactElement<DocumentProps>) => {
  const blob = await pdf(report).toBlob();
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return (await new Promise((resolve, reject) => {
    reader.onloadend = function () {
      if (reader.error) {
        reject(reader.error);
      } else {
        resolve(reader.result as string);
      }
    };
  })) as string;
};

export const downloadBase64File = (base64data: string, fileName: string) => {
  if (base64data) {
    const a = document.createElement('a');
    a.href = base64data;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};

export const convertListToText = (arr: string[]) => {
  return arr.length > 1 ? arr.join(', ') : arr.join('');
};

export const toTitleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getEDMSLink = (id?: string) =>
  `${window.REACT_APP_EXTERNAL_DOCUMENT_REPO_URL_PATH}${id}`;
